/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AuthConfigResponse } from '../models/auth-config-response';
import { AuthConfigurationsResponse } from '../models/auth-configurations-response';
import { brandOAuthProvidersGet } from '../fn/tenant-auth-configurations/brand-o-auth-providers-get';
import { BrandOAuthProvidersGet$Params } from '../fn/tenant-auth-configurations/brand-o-auth-providers-get';
import { BrandOAuthProvidersResult } from '../models/brand-o-auth-providers-result';
import { tenantAuthConfigPost } from '../fn/tenant-auth-configurations/tenant-auth-config-post';
import { TenantAuthConfigPost$Params } from '../fn/tenant-auth-configurations/tenant-auth-config-post';
import { tenantAuthConfigurationsGet } from '../fn/tenant-auth-configurations/tenant-auth-configurations-get';
import { TenantAuthConfigurationsGet$Params } from '../fn/tenant-auth-configurations/tenant-auth-configurations-get';
import { updateOAuthProvider } from '../fn/tenant-auth-configurations/update-o-auth-provider';
import { UpdateOAuthProvider$Params } from '../fn/tenant-auth-configurations/update-o-auth-provider';

@Injectable({ providedIn: 'root' })
export class TenantAuthConfigurationsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `tenantAuthConfigurationsGet()` */
  static readonly TenantAuthConfigurationsGetPath = '/auth-configurations';

  /**
   * Gets auth configuration  for a specified tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantAuthConfigurationsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantAuthConfigurationsGet$Response(params: TenantAuthConfigurationsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthConfigurationsResponse>> {
    return tenantAuthConfigurationsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets auth configuration  for a specified tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantAuthConfigurationsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantAuthConfigurationsGet(params: TenantAuthConfigurationsGet$Params, context?: HttpContext): Observable<AuthConfigurationsResponse> {
    return this.tenantAuthConfigurationsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthConfigurationsResponse>): AuthConfigurationsResponse => r.body)
    );
  }

  /** Path part for operation `tenantAuthConfigPost()` */
  static readonly TenantAuthConfigPostPath = '/auth-configurations';

  /**
   * Creates a new Auth Configuration for a specified tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantAuthConfigPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantAuthConfigPost$Response(params: TenantAuthConfigPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthConfigResponse>> {
    return tenantAuthConfigPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new Auth Configuration for a specified tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantAuthConfigPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantAuthConfigPost(params: TenantAuthConfigPost$Params, context?: HttpContext): Observable<AuthConfigResponse> {
    return this.tenantAuthConfigPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthConfigResponse>): AuthConfigResponse => r.body)
    );
  }

  /** Path part for operation `brandOAuthProvidersGet()` */
  static readonly BrandOAuthProvidersGetPath = '/brands/oauth-providers';

  /**
   * Returns tenant OAuth providers
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `brandOAuthProvidersGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  brandOAuthProvidersGet$Response(params: BrandOAuthProvidersGet$Params, context?: HttpContext): Observable<StrictHttpResponse<BrandOAuthProvidersResult>> {
    return brandOAuthProvidersGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns tenant OAuth providers
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `brandOAuthProvidersGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  brandOAuthProvidersGet(params: BrandOAuthProvidersGet$Params, context?: HttpContext): Observable<BrandOAuthProvidersResult> {
    return this.brandOAuthProvidersGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<BrandOAuthProvidersResult>): BrandOAuthProvidersResult => r.body)
    );
  }

  /** Path part for operation `updateOAuthProvider()` */
  static readonly UpdateOAuthProviderPath = '/brands/oauth-providers/{providerName}';

  /**
   * Add or update social identity provider configuration with cognito for a tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOAuthProvider()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOAuthProvider$Response(params: UpdateOAuthProvider$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateOAuthProvider(this.http, this.rootUrl, params, context);
  }

  /**
   * Add or update social identity provider configuration with cognito for a tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOAuthProvider$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOAuthProvider(params: UpdateOAuthProvider$Params, context?: HttpContext): Observable<void> {
    return this.updateOAuthProvider$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
